export const SHOW_NOTICE = 'NOTICES/SHOW_NOTICE';
export const CLEAR_NOTICE = 'NOTICES/CLEAR_NOTICE';

/** How long a banner stays up when it isn't tapped. */
export const NOTICE_SECONDS = 8;
